import React, { useState } from "react";
import { ProblemsDictionary } from "../../types/Metadata";
import { Button } from "../../components/ui/button";

const Modal = ({
  headerTitle,
  setShowModal,
  saveItems,
  headers,
  vals,
}: {
  headerTitle: string;
  setShowModal: any;
  saveItems: (name: string[]) => void;
  headers: string[];
  vals: string[];
}) => {
  const [values, setValues] = useState<string[]>(
    vals ? [...vals] : Array.apply(null, Array(headers.length)).map(() => "")
  );
  return (
    <>
      {/* Backdrop */}
      <div className="fixed inset-0 z-40 bg-black/25" onClick={() => setShowModal(false)} />

      {/* Dialog */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-[var(--sc-surface)] rounded-[14px] w-[480px] shadow-[0_20px_60px_rgba(0,0,0,0.18)] flex flex-col">

          {/* Header */}
          <div className="flex items-center justify-between px-5 pt-5 pb-4 border-b border-[var(--sc-border)]">
            <h3 className="text-[15px] font-semibold text-[var(--sc-text)]">{headerTitle}</h3>
            <button
              className="w-7 h-7 rounded-[6px] border border-[var(--sc-border)] flex items-center justify-center text-[var(--sc-muted)] hover:text-[var(--sc-text)] hover:bg-[var(--sc-bg)] text-sm transition-colors"
              onClick={() => setShowModal(false)}
            >
              ×
            </button>
          </div>

          {/* Body */}
          <div className="px-5 py-4 flex flex-col gap-3">
            {headers.map((header, index) => (
              <div key={index}>
                <label className="block text-xs font-medium text-[var(--sc-muted)] uppercase tracking-[0.06em] mb-1.5">
                  {header}
                </label>
                <textarea
                  className="w-full min-h-[72px] rounded-[6px] border border-[var(--sc-border)] bg-[#F2F2F0] px-3 py-2 text-sm text-[var(--sc-text)] placeholder:text-[var(--sc-muted)] focus:outline-none focus:bg-[#EAF0F8] focus:border-[#99AECB] resize-none transition-colors"
                  value={values[index]}
                  onChange={(e) => {
                    const copy = [...values];
                    copy[index] = e.target.value;
                    setValues(copy);
                  }}
                />
              </div>
            ))}
          </div>

          {/* Footer */}
          <div className="flex items-center justify-end gap-2 px-5 pb-5">
            <Button variant="secondary" size="sm" onClick={() => setShowModal(false)}>
              Zamknij
            </Button>
            <Button size="sm" onClick={() => { saveItems(values); setShowModal(false); }}>
              Zapisz
            </Button>
          </div>

        </div>
      </div>
    </>
  );
};

export default function AddItemsModal({
  saveItems,
  text,
  children,
  headers,
  vals = [],
}: {
  text: string;
  saveItems: (name: string[]) => void;
  headers: string[];
  children?: any;
  problemsDictionary?: ProblemsDictionary;
  borderless?: boolean;
  vals?: string[];
}) {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <>
      <Button variant="secondary" size="sm" onClick={() => setShowModal(true)}>
        {children ?? text}
      </Button>

      {showModal && (
        <Modal
          vals={vals}
          headerTitle={text}
          saveItems={saveItems}
          headers={headers}
          setShowModal={setShowModal}
        />
      )}
    </>
  );
}
